import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import CustomProductInquiryService from '../api/CustomProductInquiryService';

const initialState = {
  loading: false,
  data: null,
  error: null,
  success: false,
};

export const getCustomProductInquiryMethod = createAsyncThunk(`/get-customProductInquiry`, async () => {
  try {
    const { data } = await CustomProductInquiryService.get();
    return data.data;
  } catch (error) {
    console.error('-------', error.message);
    throw error;
  }
});

const customProductInquirySlice = createSlice({
  name: 'customProductInquiry',
  initialState,
  reducers: {},
  extraReducers: {
    // get
    [getCustomProductInquiryMethod.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [getCustomProductInquiryMethod.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.success = true;
      state.data = payload;
    },
    [getCustomProductInquiryMethod.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
  },
});

export default customProductInquirySlice.reducer;
